import type { PropsWithChildren } from "react";
import { createContext, useContext } from "react";
import type { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";

interface CustomerIoContextProps {
  analytics: AnalyticsBrowser;
}

const CustomerIoContext = createContext<CustomerIoContextProps | null>(null);

export const useCustomerIoContext = () => {
  const context = useContext(CustomerIoContext);

  if (!context) {
    throw new Error(
      "useCustomerIoContext must be used within a <CustomerIoContextProvider />",
    );
  }

  return context;
};

type CustomerIoContextProviderProps = PropsWithChildren & {
  analytics: AnalyticsBrowser;
};

export const CustomerIoContextProvider = ({
  analytics,
  children,
}: CustomerIoContextProviderProps) => {
  return (
    <CustomerIoContext.Provider
      value={{
        analytics,
      }}
    >
      {children}
    </CustomerIoContext.Provider>
  );
};
